import { PrineConvertAdapterOptions } from './types/PrineConvertAdapterOptions';

export abstract class PrineConvertAdapterExport {
    protected options: PrineConvertAdapterOptions;

    protected constructor(options: PrineConvertAdapterOptions) {
        this.options = options;
    }

    abstract asRaw(): any;

    asString(): string {
        return this.asRaw().toString();
    }

    asDataUri(): string {
        return 'data:' + this.options.mimeType + ',' + this.asString();
    }

    download(filename: string): void {
        if (document) {
            const a = document.createElement('a');
            a.href = this.asDataUri();
            a.target = '_blank';
            a.download = filename;
            a.click();
        }
    }

    // noinspection JSUnusedGlobalSymbols
    openInNewWindow(windowname: string): void {
        if (window) {
            const opened = window.open(this.asDataUri(), '_blank');
            setTimeout(() => {
                if (opened) {
                    opened.document.title = windowname;
                }
            }, 0);
        }
    }
}
